import * as React from "react";

function SvgClockIconSmall(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={18}
      height={18}
      {...props}
    >
      <defs>
        <path
          d="M11.7 12.54L7.74 9.76V4.25h1.8v4.57l3.2 2.25-1.04 1.47z"
          id="clock-icon-small_svg__a"
        />
        <path
          d="M9 1.35C4.78 1.35 1.35 4.78 1.35 9c0 4.22 3.43 7.65 7.65 7.65 4.22 0 7.65-3.43 7.65-7.65 0-4.22-3.43-7.65-7.65-7.65M9 18c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9"
          id="clock-icon-small_svg__b"
        />
      </defs>
      <use xlinkHref="#clock-icon-small_svg__a" fill="#797a7c" />
      <use
        xlinkHref="#clock-icon-small_svg__a"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
      <g>
        <use xlinkHref="#clock-icon-small_svg__b" fill="#797a7c" />
        <use
          xlinkHref="#clock-icon-small_svg__b"
          fillOpacity={0}
          stroke="#000"
          strokeOpacity={0}
        />
      </g>
    </svg>
  );
}

export default SvgClockIconSmall;
